import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AuthService } from 'src/app/services/auth.service';
import {CommonService } from 'src/app/services/common.service'
import { SendRequestMoneyService } from 'src/app/services/send-request-money.service'
import { SendMoneyService } from '../send-money/send-money.service';

declare var MachnetWidget: any;
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit,OnDestroy {
  transactions:any=[]
  requests=[]
  startTrans = 0
  startRequest = 0
  transaction_id
  current_page
  last_page
  next_disabled = false
  prev_disabled = true
  constructor(public auth : AuthService, private common : CommonService,private messageService:MessageService, private router:Router, public requestService : SendRequestMoneyService, public sendMoneyService : SendMoneyService) { }

  ngOnInit(): void {
    this.common.showBackButton=false
    // if(this.auth.user?.mob_verified && this.auth.user?.email_verified_at)
    this.getTransactions()
    this.auth.getUserDocuments()
    // this.getPendingRequests()
  }

  addScript(senderid,token,Transaction_id){
    var widget = new MachnetWidget({
      elementId: "widget-root",
      senderId: senderid,
      transactionId:Transaction_id,
      width: "100%",
      height: "600px",
      type: "invoice",
      locale: "en",
      multiStep: true,
      //stylesheet: "https://example.com/mystyle.css",
      token: token,
    });
    widget.init();
    window.addEventListener("message", function (e) {
      //console.log("type", e.data.type)
      //console.log("all_detail", e.data)
      //console.log("all", e)
      if(e.data.status === "VERIFIED"){
        this.verifyAccount()
      }
    }.bind(this))
  }
  verifyAccount(){
    //console.log("verifing")
    this.auth.verifyUser().subscribe(res=>{
      // this.messageService.add({severity:'success', summary:'Successful', detail:"Successfully Verified Doccuments"});
      this.auth.setUser()
      this.router.navigateByUrl("/dashboard")
    },err=>{
      this.messageService.add({severity:'error', summary:'Some Error Occoured', detail:""});
    })
  }

  getPendingRequests(){
    this.auth.getMoneyRequests().subscribe(res=>{
      //console.log(res)
      this.requests=res['data']
    })
  }

  approveMoneyRequest(req){
    this.requestService.request = req
    if(!req.res_exist){
      this.router.navigateByUrl('/add-request-recipient')
    }
    else{
      this.auth.requestAction({id:req.id,status:1}).subscribe(res=>{
      //console.log(res)
      // this.getPendingRequests()
      this.requestService.assign(res['receiver'], res['purpose']['reason'], true, res['amount'])
      // this.requestService.sendMoneyService.receiver = res['receiver']
      // this.requestService.sendMoneyService.purpose = res['purpose']['reason']
      // this.sendMoneyService.purpose = this.sendMoneyService.caReasons.find(element => {
      //   return element.attributes.code == res['purpose']
      // })
      // this.requestService.sendMoneyService.isAcknowlodgingRequest = true
      // this.requestService.sendMoneyService.requestedSendingAmount = res['amount']
      this.router.navigateByUrl('/send-money/step3')
    })
    }

  }
  rejectMoneyRequest(id){
    this.auth.requestAction({id:id,status:0}).subscribe(res=>{
      //console.log(res)
      this.getPendingRequests()
    })
  }

  getTransactions(page = 1){
    this.auth.getTransactions(page).subscribe((res:any)=>{
      //console.log(res)
      this.transactions=res.data
      this.current_page = +res.current_page
      this.last_page = +res.last_page
      if(+this.current_page == 1)
        this.prev_disabled = true
      else 
        this.prev_disabled = false

      if(+this.current_page == +this.last_page)
        this.next_disabled = true
      else 
        this.next_disabled = false
      // this.
      //console.log(this.transactions)
    },err=>{
      //console.log(err)
    })
  }



  resendEmail(){
    this.common.showLoader()
    this.auth.resendverify().subscribe(res=>{
      this.common.stopLoader()
      //console.log(res)
      // this.messageService.add({severity:'success', summary:'Successful', detail:"Please Check your Email Again"});
    },err=>{
      let errorKeys = Object.keys(err.error.errors); 
      errorKeys.forEach(key => { 
        //console.log(key)
        let value = err.error.errors[key][0]; 
        this.messageService.add({severity:'error', summary:value, detail:""});
        //console.log(value); 
    }); 
      //console.log(err)
      this.common.stopLoader()
    })
  }


  prev(){
      this.startTrans -= 5
  }
  next(){
      this.startTrans += 5
   }

   prevRequest(){
    this.startRequest -= 10
}
nextRequest(){
    this.startRequest += 10
 }
 disableTransNext(){
  if(this.transactions.length<=5)
    return true
  else
    return parseInt((this.transactions.length / 5).toString()) == (this.startTrans/5) ? true : false
}
disableReqNext(){
  return parseInt((this.requests.length / 10).toString()) == (this.startRequest/10) ? true : false
}

ngOnDestroy(){
  this.common.showBackButton=true
}
assign(id){
  this.common.showLoader()
  this.transaction_id=id
  //console.log(this.transaction_id)



  this.auth.getWidgetToken().subscribe((res:any)=>{
    //console.log(res)
    this.addScript(this.auth.user.uuid,res.token,this.transaction_id)
  this.common.stopLoader()
  },err=>{
    let errorKeys = Object.keys(err.error.errors); 
    errorKeys.forEach(key => { 
      //console.log(key)
      let value = err.error.errors[key][0]; 
      this.messageService.add({severity:'error', summary:value, detail:""});
      //console.log(value); 
  }); 
    //console.log(err)
    this.common.stopLoader()
  })
}

cancelTransaction(trans_id){
  this.sendMoneyService.cancelTransaction(trans_id)
  .subscribe((res:any) => {
    // //console.log(res)
    this.messageService.add({severity:'success',summary:res.message})
    setTimeout(()=>{
      window.location.reload()
    },2500)
  }, err => {
    //console.log(err)
  })
}
}
